import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiInterceptorInterceptor } from './services/api-interceptor.interceptor';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastrModule } from 'ngx-toastr';
import { NgbModule, NgbDateParserFormatter,NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
// import '@angular/localize/init';
import { DataTablesModule } from 'angular-datatables'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { BoardDetailsComponent } from './board-details/board-details.component';
// import { LoginPagesComponent } from './login-pages/login-pages.component';
import { AssemblyProcessComponent } from './assembly-process/assembly-process.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { FooterComponent } from './footer/footer.component';
import { QuoteDetailsComponent } from './quote-details/quote-details.component';
import { OrderReviewComponent } from './order-review/order-review.component';
import { OrderStatusComponent } from './order-status/order-status.component';
import { OrderDetailsComponent } from './order-details/order-details.component';
// import { CreateAddressComponent } from './create-address/create-address.component';
import { BomAssemblyProcessComponent } from './bom-assembly-process/bom-assembly-process.component';
import { SearchAssistComponent } from './search-assist/search-assist.component';
import { BomProcessComponent } from './bom-process/bom-process.component';
import { ComponentProcurementComponent } from './component-procurement/component-procurement.component';
import { QuoteStatusComponent } from './quote-status/quote-status.component';
// import { CustomQuoteDashboardComponent } from './custom-quote-dashboard/custom-quote-dashboard.component';
import { AdditionalComponentDetailsComponent } from './additional-component-details/additional-component-details.component';
import { AdminDashboardComponent, CustomDateParserFormatter } from './admin-dashboard/admin-dashboard.component';
import { CustomQuoteComponentProcurementComponent } from './custom-quote-component-procurement/custom-quote-component-procurement.component';

import {
  Idle,
  NgIdleModule,
  DEFAULT_INTERRUPTSOURCES
} from '@ng-idle/core';

import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5';

import JSZip from 'jszip';
// @ts-ignore
(window as any).JSZip = JSZip;


@NgModule({ declarations: [
    ],
     imports: [BrowserModule,
        AppRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        BrowserAnimationsModule,
        DataTablesModule,
        ToastrModule.forRoot({
            maxOpened: 1,
            preventDuplicates: true
        }),
        NgIdleModule.forRoot(),
        NgIdleKeepaliveModule.forRoot(),
        NgbDatepickerModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptorInterceptor,
            multi: true,
        },
        CookieService,
        Idle,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
